import * as Session from 'supertokens-web-js/recipe/session'
import { useLogger } from '~/composables/useLogger'

export const useAuth = () => {
  const { logError } = useLogger()
  const getAuthenticatedFetch = (): typeof fetch => {
    if (
      typeof window !== 'undefined' &&
      (window as Window & { authenticatedFetch?: typeof fetch })?.authenticatedFetch
    ) {
      return (window as Window & { authenticatedFetch?: typeof fetch }).authenticatedFetch!
    }
    return fetch // fallback to regular fetch
  }

  const apiCall = async (url: string, options: RequestInit = {}) => {
    const authenticatedFetch = getAuthenticatedFetch()
    return authenticatedFetch(url, {
      ...options,
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    })
  }

  const doesSessionExist = async (): Promise<boolean> => {
    try {
      return await Session.doesSessionExist()
    } catch (error) {
      logError('Error checking session:', error)
      return false
    }
  }

  const signOut = async (): Promise<void> => {
    try {
      await Session.signOut()
    } catch (error) {
      logError('Error signing out:', error)
      throw error
    }
  }

  const getUserId = async (): Promise<string | undefined> => {
    try {
      return await Session.getUserId()
    } catch (error) {
      logError('Error getting user ID:', error)
      return undefined
    }
  }

  const getAccessToken = async (): Promise<string | undefined> => {
    try {
      return await Session.getAccessToken()
    } catch (error) {
      logError('Error getting access token:', error)
      return undefined
    }
  }

  return {
    apiCall,
    doesSessionExist,
    signOut,
    getUserId,
    getAccessToken,
    getAuthenticatedFetch,
  }
}
